module.exports = __webpack_public_path__ + "img/e-commerce-mobile.53545073.jpg";